@let image = profileImage();
<button md-button md-button-circle (click)="fileInput.click()" [ngStyle]="{ 'background-image': image ? 'url(' + image + ')' : 'none' }">
	<md-icon [ngClass]="{ 'with-img': !!image }" icon="untitled-ui/images/image-03"></md-icon>
	<input #fileInput type="file" accept="image/jpeg, image/png" (change)="getDataUrl(fileInput.files)" />
</button>
<span class="max-file-size-msg">Max Size: {{ maxFileSizeDisplay }}</span>

<div class="actions">
	<button md-button (click)="fileInput.click()"> <md-icon icon="untitled-ui/general/edit-05"></md-icon> </button>
	<button md-button (click)="removeProfile()"> <md-icon icon="untitled-ui/general/trash-01"></md-icon> </button>
</div>